import { format } from 'libphonenumber-js';

export const formatPhoneNumber = (number: string): string => format(number, 'US', 'NATIONAL');

export default formatPhoneNumber;
